import { Bill } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { LocalizedParagraph } from '@mews-commander/ui';
import { Container, Highlight, NestedCard, Stack, StackItem } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { getCustomerOrCompanyFullName } from '@mews-commander/legacy-entities/src/ducks/customers';
import { useCommanderSelector } from '@mews-commander/utils';

interface NewBillInfoProps {
    bill: Bill;
}

export const NewBillInfo = ({ bill }: NewBillInfoProps) => {
    const ownerName = useCommanderSelector((state) => getCustomerOrCompanyFullName(state, { id: bill.ownerId }));
    const associateAccountName = useCommanderSelector((state) =>
        bill?.associatedAccountId ? getCustomerOrCompanyFullName(state, { id: bill.associatedAccountId }) : null
    );

    return (
        <NestedCard padding="100">
            <Container padding="100">
                <Stack vertical spacing="100">
                    <StackItem>
                        <LocalizedParagraph textKey={TextKey.BillOwnedBy} />
                        <Highlight size="medium" ellipsis maxLines={1}>
                            {ownerName}
                        </Highlight>
                    </StackItem>
                    <StackItem>
                        <LocalizedParagraph textKey={TextKey.BillAssociatedWith} />
                        <Highlight size="medium" ellipsis maxLines={1}>
                            {associateAccountName || <LocalizedText textKey={TextKey.None} />}
                        </Highlight>
                    </StackItem>
                </Stack>
            </Container>
        </NestedCard>
    );
};
